import './ModuleContents.scss';
import { ModuleCTA } from 'components/ModuleCTA/ModuleCTA';
import { TableOfContents } from 'pages/TableOfContents/TableOfContents';
import { ModuleTableOfContents } from 'types/learningHub/moduleContents';

type ModuleContentsProps = {
  contents: ModuleTableOfContents;
  isModuleCompleted: boolean;
  isModuleStarted: boolean;
  slug: string;
};

export const ModuleContents = ({ contents, isModuleCompleted, isModuleStarted, slug }: ModuleContentsProps) => {
  return (
    <div className='module-contents-wrapper'>
      <ModuleCTA isModuleCompleted={isModuleCompleted} isModuleStarted={isModuleStarted} slug={slug}></ModuleCTA>
      <TableOfContents contents={contents} isInteractive={false} handleEntrySelection={() => {}}></TableOfContents>
    </div>
  );
};
